﻿import { format } from "date-fns";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function TransactionLists({
  entradas,
  saidas,
  openRegister,
  setIsExpenseModalOpen,
}: {
  entradas: any[];
  saidas: any[];
  openRegister: any;
  setIsExpenseModalOpen: (val: boolean) => void;
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="bg-slate-800/80 border border-slate-700 rounded-xl p-6 shadow-lg">
        <h2 className="text-xl font-bold text-white mb-6 flex items-center">
          <ArrowUpRight className="text-emerald-400 mr-2" />
          Movimentações de Entrada
        </h2>
        <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2">
          {entradas.length === 0 ? (
            <p className="text-slate-400 text-sm text-center py-4">
              Nenhuma entrada registrada na sessão atual.
            </p>
          ) : (
            entradas.map((tx: any) => (
              <div
                key={tx.id}
                className="flex justify-between items-center p-4 bg-slate-900/50 rounded-lg border border-slate-700/50"
              >
                <div>
                  <p className="font-semibold text-slate-200">
                    {tx.description}
                  </p>
                  <p className="text-xs text-slate-400 mt-1 flex gap-2">
                    <span>{format(new Date(tx.created_at), "HH:mm")}</span>
                    <span className="bg-slate-800 px-2 rounded-sm border border-slate-700 uppercase">
                      {tx.method}
                    </span>
                  </p>
                </div>
                <div className="font-bold text-emerald-400">
                  + R$ {Number(tx.amount).toFixed(2)}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <div className="bg-slate-800/80 border border-slate-700 rounded-xl p-6 shadow-lg">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-white flex items-center">
            <ArrowDownRight className="text-red-400 mr-2" />
            Despesas e Saídas
          </h2>
          <Button
            size="sm"
            className="bg-slate-700 hover:bg-slate-600 text-white font-medium px-4"
            disabled={!openRegister}
            onClick={() => setIsExpenseModalOpen(true)}
          >
            Lançar
          </Button>
        </div>
        <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2">
          {saidas.length === 0 ? (
            <p className="text-slate-400 text-sm text-center py-4">
              Nenhuma despesa registrada na sessão atual.
            </p>
          ) : (
            saidas.map((exp: any) => (
              <div
                key={exp.id}
                className="flex justify-between items-center p-4 bg-slate-900/50 rounded-lg border border-slate-700/50"
              >
                <div>
                  <span className="text-[10px] uppercase font-bold px-2 py-0.5 bg-red-900/30 text-red-400 rounded border border-red-900/50 mb-1 inline-block">
                    {exp.category || "GERAL"}
                  </span>
                  <p className="font-semibold text-slate-200">
                    {exp.description}
                  </p>
                  <p className="text-xs text-slate-400 mt-1 flex gap-2">
                    <span>{format(new Date(exp.created_at), "HH:mm")}</span>
                    <span className="bg-slate-800 px-2 rounded-sm border border-slate-700 uppercase">
                      {exp.method || "N/A"}
                    </span>
                  </p>
                </div>
                <div className="font-bold text-red-400">
                  - R$ {Number(exp.amount).toFixed(2)}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
